module.exports = __webpack_public_path__ + "icon_copy_gray.d456d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_copy_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_copy_gray.svg
// module chunks = main